import { useState } from 'react';
import { useSelector } from 'react-redux';
import { exposeEventToPartner } from '../../Helpers/events';

const useFirstInteraction = () => {
  const [firstInteractionComplete, setFirstInteractionComplete] =
    useState(false);
  const { widgetLabel, iFrameId } = useSelector(
    (store) => store.optionalFormConfig
  );

  const exposeInitialWidgetInteractionEvent = () => {
    if (!firstInteractionComplete) {
      setFirstInteractionComplete(true);
      exposeEventToPartner({
        eventType: 'initialWidgetInteraction',
        eventObject: {
          widgetLabel,
          iFrameId,
        },
      });
    }
  };

  return { exposeInitialWidgetInteractionEvent };
};

export default useFirstInteraction;
